var _excluded = ["onChange"],
    _excluded2 = ["className", "disabled", "id", "name", "placeholder"];

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import Input from "../Input/Input";
import COUNTRIES from "./util/Countries"; // TODO i18n country names based on locale

var defaultProps = {
  onChange: function onChange() {}
};

var CountryInput = function CountryInput(_ref) {
  var _ref$onChange = _ref.onChange,
      _onChange = _ref$onChange === void 0 ? defaultProps.onChange : _ref$onChange,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var className = otherProps.className,
      disabled = otherProps.disabled,
      id = otherProps.id,
      name = otherProps.name,
      placeholder = otherProps.placeholder,
      props = _objectWithoutProperties(otherProps, _excluded2);

  var classNames = classnames('custom-select', className);
  return /*#__PURE__*/React.createElement(Input, _extends({
    type: "select"
  }, props, {
    className: classNames,
    disabled: disabled,
    id: id,
    name: name,
    onChange: function onChange(e) {
      return _onChange(e.target.value === '' ? null : e.target.value);
    }
  }), /*#__PURE__*/React.createElement("option", {
    value: ""
  }, placeholder), COUNTRIES.map(function (country) {
    return /*#__PURE__*/React.createElement("option", {
      value: country.value,
      key: country.value
    }, country.label);
  }));
};

CountryInput.displayName = "CountryInput";
CountryInput.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  value: PropTypes.string
};
CountryInput.defaultProps = defaultProps;
CountryInput.displayName = 'CountryInput';
export default CountryInput;